function setNotifications(data) {
	return {
		type: 'SET_NOTIFICATIONS',
		payload: data,
	};
}

export { setNotifications };
